import React, { useEffect, useState, useRef } from 'react';
import useCloseOnBlur from '../../../../customHooks/useCloseOnBlur';
import CustomLink from '../../../UI/CustomLink';
import SearchResultItem from '../SearchResultItem/SearchResultItem';
import styles from './SearchResultList.module.scss';
import Loader from '../../../UI/Loader/Loader';
import cls from 'classnames';

const SearchResultList = ({
  isVisible,
  foundProducts,
  searchValue,
  closeDropdown,
  searchIsLoading,
}) => {
  const [trimmedProducts, handleTrimmedProducts] = useState([]);

  const wrapperRef = useRef(null);
  useCloseOnBlur(wrapperRef, closeDropdown);

  useEffect(() => {
    handleTrimmedProducts(foundProducts ? foundProducts.slice(0, 3) : []);
  }, [foundProducts]);

  return (
    <>
      {
        !!isVisible
        && (
          <div
            className={styles.searchResults}
            ref={wrapperRef}
          >
            <div className={cls(styles.searchResultsInner, {[styles.loading]: searchIsLoading})}>
              {
                trimmedProducts.map((product) => (
                  <SearchResultItem
                    username={product.user.username}
                    productLink={product.link}
                    imgUrl={product.preview.thumb}
                    title={product.title}
                    categories={product.categories}
                    key={product.id}
                  />
                ))
              }
              {
                foundProducts && foundProducts.length > 3
                && (
                  <CustomLink
                    href={`/search?query=${searchValue}`}
                    as={`/search?query=${searchValue}`}
                    className={styles.searchResultsLink}
                  >
                    <span>All Results</span>
                  </CustomLink>
                )
              }
              {searchIsLoading && (<Loader />)}
            </div>
          </div>
        )
      }
    </>
  );
};

export default SearchResultList;
